module.exports = __webpack_public_path__ + "static/media/circle-question.eaa6d1c4.svg";